import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import fabricator from './fabricator';
import features from './features';
import search from './search';
import stones from './stones';
import stonesV2 from './stones_v2';
import customers from './customers';
import employees from './../components/Employees/EmployeesReducer';
import fabricators from './../components/Fabricators/FabricatorsReducer';
import stores from './stores';
import entities from './entities';
import editor from './editor';
import auth from './auth';
import jobBoard from '../components/JobBoard/JobBoardReducer';
import popups from './R_Popups';
import calendar from './R_Calendar';
import accountState from '../components/Account/AccountReducer';
import newaccount from '../components/AddNewEntity/AddEntityReducer';
import permissions from './permissions';
import pricingPreset from './pricingPreset';
import visualizerManagement from '../components/VisualizerManagement/VisualizerManagementReducer';
import sites from '../components/Sites/SitesReducer';
import filters from './../components/Filters/FiltersReducer';
import skuFilters from './../components/Filters/SkuFilters/SkuFiltersReducers';
import skuFiltersAssignToProduct from './../components/Filters/SkuFilters/SkuFiltersAssignToProductReducers';
import filtersAssignToFeatures from './../components/Filters/Features/Reducer';
import featureInclusion from './featureInclusion';
import filtersAssignToStones from './../components/Filters/Stones/Reducer';
import newStone from './../components/StoneSetup/NewStonePopup/newStonePopupReducer';
import asCustomer from './asCustomer';
import projectScope from './../components/ProjectScope/ProjectScopeReducer';
import taxesReducer from './../components/Taxes/TaxesReducer';
import newFeatureGroup from './../components/ProjectScope/NewFeatureGroup/NewFeatureGroupReducer';
import installations from './../components/Installations/InstallationReducer';
import newInstallationGroup from './../components/Installations/NewInstallationGroup/NewInstallationGroupReducer';
import newInstallationGroupItem from './../components/Installations/InstallationGroupItems/NewInstallationGroupItem/NewInstallationGroupItemReducer'
import newFeature from './../components/FeatureCreator/NewFeature/NewFeatureReducer';
import purchase from '../components/Purchase/purchaseReducer';
import pricingState from '../components/Pricing/pricingReducer';
import newScope from '../components/NewScope/newScopeReducer';
import projectScopeNew from '../components/ProjectScope/ProjectScopeReducerNew';
import featuresCreatorNew from '../components/FeatureCreator/FeatureCreatorReducerNew';
import discountsState from '../components/Discounts/discountsReducer';
import featuresFiltersState from '../components/FeatureCreator/FeaturesFilters/FeaturesFiltersReducer';
import assignQuoteState from '../components/PageLayout/Popups/AssignQuotePopup/assignQuoteReducer';
import wizardState from '../components/WizardSetup/wizardReducer';
import dashboardState from './dashboard';
import featuresSetupState from '../components/FeaturesSetup/featuresReducer';
import jobPaymentState from '../components/JobBoard/jobPaymentPopup/jobPaymentReducer';
import contractsState from '../components/FingerSignature/contractsReducer.js';
import jobEditPopupState from "../components/JobBoard/jobEditPopup/jobEditPopupReducer";
import jobPurchaseOrderPopupState from "../components/JobBoard/jobPurchaseOrderPopup/jobPurchaseOrderReducer.js";

const rootReducer = combineReducers({
  routing,
  entities,
  editor,
  fabricator,
  features,
  search,
  stones,
  auth,
  jobBoard,
  popups,
  calendar,
  form,
  customers,
  employees,
  fabricators,
  stores,
  accountState,
  newaccount,
  permissions,
  pricingPreset,
  sites,
  filters,
  skuFilters,
  skuFiltersAssignToProduct,
  visualizerManagement,
  filtersAssignToFeatures,
  featureInclusion,
  filtersAssignToStones,
  newStone,
  asCustomer,
  stonesV2,
  projectScope,
  taxes: taxesReducer,
  newFeatureGroup,
  installations,
  newInstallationGroup,
  newInstallationGroupItem,
  newFeature,
  purchase,
  newScope,
  projectScopeNew,
  featuresCreatorNew,
  discountsState,
  featuresFiltersState,
  dashboardState,
  assignQuoteState,
  wizardState,
  featuresSetupState,
  jobPaymentState,
  jobEditPopupState,
  jobPurchaseOrderPopupState,
  contractsState,
  pricingState,
});

export const PersistStoreWhitelist = [
  'auth'
];

export default rootReducer;

export const Popups = (state) => state.popups;
